module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8vJUX"))).then(() => parcelRequire('1iHdE'));